import * as Yup from "yup";
import { VALIDATION_KEYS } from "../../utils/translation-constants";
import validationConfig from "custom/config/validation.config.json";
const biStatementConfig = validationConfig["downloadCenter"]["biStatement"];
const mt103Config = validationConfig["downloadCenter"]["mt103"];
const receiptConfig = validationConfig["downloadCenter"]["receipt"];

const validateBiStmtAccountNo = biStatementConfig["isAccountNoRequired"]
  ? {
    accountNo: Yup.string().required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }
  : {
      accountNo: Yup.string().optional(),
    };
const validateBiStmtFromDate = biStatementConfig["isFromDateRequired"]
  ? {
    fromDate: Yup.date()
    .max(new Date(), VALIDATION_KEYS.FROM_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.FROM_DATE_REQUIRED)
    }
  : {
      fromDate: Yup.string().optional(),
    };

const validateBiStmtToDate = biStatementConfig["isToDateRequired"]
  ? {
    toDate: Yup.date()
    .min(Yup.ref('fromDate'), VALIDATION_KEYS.TO_DATE_GREATER_FROM_DATE)
    .max(new Date(), VALIDATION_KEYS.TO_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.TO_DATE_REQUIRED),
    }
  : {
      toDate: Yup.string().optional(),
    };

const validateBiStmtFormat = biStatementConfig["isFormatRequired"]
  ? {
    format: Yup.string().required(VALIDATION_KEYS.FORMAT_REQUIRED),
    }
  : {
      format: Yup.string().optional(),
    };

const validateBiStmtReportName = biStatementConfig["isReportNameRequired"]
  ? {
    reportName: Yup.string().required(VALIDATION_KEYS.REPORTER_NAME_REQUIRED),
    }
  : {
      reportName: Yup.string().optional(),
    };

const validatemt103AccountNo = mt103Config["isAccountNoRequired"]
  ? {
    sourceAccount: Yup.string().required(VALIDATION_KEYS.ACCOUNT_NO_REQUIRED),
    }
  : {
      sourceAccount: Yup.string().optional(),
    };
const validatemt103FromDate = mt103Config["isFromDateRequired"]
  ? {
    fromDate: Yup.date()
    .max(new Date(),  VALIDATION_KEYS.FROM_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.FROM_DATE_REQUIRED),
    }
  : {
      fromDate: Yup.string().optional(),
    };

const validatemt103ToDate = mt103Config["isToDateRequired"]
  ? {
    toDate: Yup.date()
    .min(Yup.ref('fromDate'),VALIDATION_KEYS.TO_DATE_GREATER_FROM_DATE)
    .max(new Date(),  VALIDATION_KEYS.TO_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.TO_DATE_REQUIRED)
    }
  : {
      toDate: Yup.string().optional(),
    };

const validateReceiptFromDate = receiptConfig["isFromDateRequired"]
  ? {
    fromDate: Yup.date()
    .max(new Date(), VALIDATION_KEYS.FROM_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.FROM_DATE_REQUIRED)
    }
  : {
      fromDate: Yup.string().optional(),
    };

const validateReceiptToDate = receiptConfig["isToDateRequired"]
  ? {
    toDate: Yup.date()
    .min(Yup.ref('fromDate'), VALIDATION_KEYS.TO_DATE_GREATER_FROM_DATE)
    .max(new Date(), VALIDATION_KEYS.TO_DATE_FUTURE_DATE)
    .required(VALIDATION_KEYS.TO_DATE_REQUIRED),
    }
  : {
      toDate: Yup.string().optional(),
    };

export const BIStatementSchema = Yup.object().shape({
  ...validateBiStmtAccountNo,
  ...validateBiStmtFromDate,
  ...validateBiStmtToDate,
  ...validateBiStmtFormat,
  ...validateBiStmtReportName,
});

export const MT103Schema = Yup.object().shape({
  ...validatemt103AccountNo,
  ...validatemt103FromDate,
  ...validatemt103ToDate,
});

export const ReceiptSchema = Yup.object().shape({
  ...validateReceiptFromDate,
  ...validateReceiptToDate,
});
